module.exports = __webpack_public_path__ + "static/media/prof.f00aa2d3.jpg";